<ng-container *ngIf="enableNewVersion">
  <div fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" class="new-summary">
    <ng-container *ngFor="let member of familyMembers | slice: 0 : thresholdMembers; let i = index">
      <span class="user-icon-container cls_mask" [title]="member.firstName + ' ' + member.lastName">
        <pgh-avatar name="{{ member.firstName + ' ' + member.lastName }}" color="{{ member.avatarColor }}" size="50"></pgh-avatar>
        <!--<img [alt]="member.userGivenName ? member.userGivenName : ''"
             [src]="member.avatarUrl || './assets/images/avatars/desktop.png'"
             [class.primary-img]="i==0" />-->
        <!-- TODO: Remove the self check after Demo -->
        <mat-icon *ngIf="i == 0" class="primary-account-icon" svgIcon="checkmark-circle"> </mat-icon>
      </span>
      <mat-divider
        [vertical]="true"
        class="divider"
        *ngIf="(i === 0 && familyMembers && !disableAccount) || (i === 0 && familyMembers.length !== 1)"></mat-divider>
      <div *ngIf="familyMembers.length === 1 && familyManagementLink && familyManagementLink.route && !disableAccount">
        <div class="d-flex flex-row align-items-center">
          <a
            *ngIf="!disableAccount"
            routerLink="{{ familyManagementLink.route }}"
            class="family-link"
            gtmClick=">"
            gtmLinkURL="Dashboard Chevron Link">
            <label fxLayout="row" fxLayoutAlign="start center">
              {{ familyManagementLink.label }}<mat-icon [svgIcon]="'chevron-right-gray'"></mat-icon>
            </label>
          </a>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="familyMembers.length > thresholdMembers">
      <div>+ {{ familyMembers.length - thresholdMembers }} More</div>
    </ng-container>
  </div>
</ng-container>
<ng-container *ngIf="!enableNewVersion">
  <div fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
    <span
      class="user-icon-container cls_mask"
      *ngFor="let member of familyMembers | slice: 0 : 3; let i = index"
      [title]="member.firstName + ' ' + member.lastName">
      <pgh-avatar name="{{ member.firstName + ' ' + member.lastName }}" color="{{ member.avatarColor }}" size="50"></pgh-avatar>
      <!--<img [alt]="member.userGivenName ? member.userGivenName : ''"
           [src]="member.avatarUrl || './assets/images/avatars/desktop.png'" />-->
      <!-- TODO: Remove the self check after Demo -->
      <!--<mat-icon *ngIf="member.emailAddress === primaryEmail && member.relationship === 'Self'" class="primary-account-icon" svgIcon="primary-account">
      </mat-icon>-->
    </span>
    <ng-container *ngIf="familyMembers.length > 3">
      <div>+ {{ familyMembers.length - 3 }} More</div>
    </ng-container>
  </div>
</ng-container>
